export default "__VITE_ASSET__0bca4d9b__"